import React, { useState, useEffect } from "react";
import { functions } from "../../firebase";
import { Typography } from "@material-ui/core";
import Payments from "./PaymentTable";
import PaymentsLoading from "./PaymentsLoading"; // New smaller loader

const getPaymentData = functions.httpsCallable("getPaymentData");

const PaymentsSection = ({ query, uid }) => {
  const [loading, setLoading] = useState(true);
  const [merged, setMerged] = useState({});
  const [multas, setMultas] = useState([]);
  const [reloadData, setReloadData] = useState(0);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadPaymentData = async () => {
      if (!query) return;

      setLoading(true);
      setError(false);

      try {
        console.log("Loading fresh payment data");
        const { data } = await getPaymentData(query);

        if (data.error) {
          setError(true);
        } else {
          setMerged(data.merged || {});
          setMultas(data.multas || []);
        }
      } catch (error) {
        console.error("Error loading payment data:", error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadPaymentData();
  }, [query, reloadData]);

  const handleReload = () => {
    setReloadData(reloadData + 1);
  };

  return (
    <div>
      <Typography
        variant="h5"
        align="center"
        gutterBottom
        style={{
          marginBottom: "24px",
          marginTop: "40px",
          fontSize: "2.1rem",
        }}
      >
        Pagos
      </Typography>

      {loading ? (
        <PaymentsLoading />
      ) : error ? (
        <Typography variant="body1" align="center" color="error">
          Error cargando datos de pagos
        </Typography>
      ) : (
        <Payments
          data={merged}
          multas={multas}
          reload={handleReload}
          uid={uid}
        />
      )}
    </div>
  );
};

export default PaymentsSection;
